import type { JSX } from 'react';

type FormFieldChildrenProps = {
  describedById?: string;
  // children: React.ReactNode;
  render: (describedById: string | undefined) => JSX.Element;
};

/**
 * Skapa FormField children compability
 *
 * Children in the Skapa FormField component have to accept describedById-prop. This mean that a
 * normal html-element cause errors (console error output when running in broswer). This component
 * can be used as the child to circumvent this problem.
 */
export const FormFieldChildren: React.FC<FormFieldChildrenProps> = ({ describedById, render }) => {
  return render(describedById);
};
